import { WidgetDto } from "@intelligems/ig-types";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { usePutWidget } from "@src/api/widgets/put-widget";
import { useDispatch } from "@src/store";
import { closeWidget } from "@src/store/slices/widgets";
import { mpClickSaveWidgetButton } from "@src/utils/mixpanel";

export function useWidgetSave(widget: WidgetDto | undefined) {
  const dispatch = useDispatch();
  const user = useLoggedInUser();
  const putWidget = usePutWidget(widget?.widgetType ?? "quantityButtons");

  const save = () => {
    if (!widget) return;

    putWidget.mutate(widget, {
      onSuccess: () => {
        mpClickSaveWidgetButton(
          user.isSuccess && user.data.user.id ? user.data.user.id : null,
          widget
        );
        dispatch(closeWidget(widget));
      },
      onError: () => {
        dispatch(closeWidget());
      },
    });
  };
  return { save, isSaving: putWidget.isPending };
}
